'use strict';
import { IPC_EVENT } from "./ipc_events";
import BookData from "./js/book_data";
import SaveTool from "./js/toolbar/save_tool";
import RecordHandlerWeb from './data/file/record_handler_web';
import TaskControl from "./js/record_task/task_control";
import { RECORD_TASK_TYPE } from "./data/user_record/record_task_type";
import { useUserStore } from "./js/user_data";
import { API_GET_USER_RECORD } from './js/api';
import { timeFormat } from "./data/time_format";
import { USER_RECORD_BUCKET } from "./js/api/user_record";
import { store } from "./store";
import { RANDOM_CHAR } from "./js/common/random_char";
import ImageControl from './js/record_task/image_control';
import EventBus from './js/event_bus';
import { READ_FILE_AS_DATA_URL } from './js/common/read_file';
import { TOOLS } from "./js/toolbar/tools";
import screenfull from "screenfull";
import { VIEW_TYPE } from "./js/view_type";

export default class BackgroundWeb {
    webBackgroundEvent = new Map();
    userData = useUserStore();

    //存檔檔案處理(因套件編譯問題,現以獨立腳本執行)
    recordHandlerWeb = null;
    //存檔任務
    recordTask = null;

    constructor() {
        this.recordHandlerWeb = new RecordHandlerWeb();

        // 取得並設置使用者資訊userData
        this.userData.userId = localStorage.getItem("uuid") || "";
        this.userData.userName = localStorage.getItem("loginAccount") || "";

        //註冊網頁版功能
        this.webBackgroundEvent.set(IPC_EVENT.GET_PATH, this.getPath.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.GET_USER_RECORD, this.getUserRecord.bind(this));

        this.webBackgroundEvent.set(IPC_EVENT.LOAD_RECORD, this.loadRecord.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.CHECK_LOG_NAME_REPEAT, this.checkLogNameRepeat.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.ADD_USER_RECORD, this.addUserRecord.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.UPDATE_USER_RECORD, this.updateUserRecord.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.DELETE_USER_RECORD, this.deleteUserRecord.bind(this));

        this.webBackgroundEvent.set(IPC_EVENT.OPEN_WEB_SITE, this.openWebSite.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.OPEN_EXE, this.openWebSite.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.OPEN_WEB_PAGE_IN_SUB_WINDOW, this.openWebSite.bind(this));

        this.webBackgroundEvent.set(IPC_EVENT.GET_COPIED_IMAGE, this.handleInsertImage.bind(this));

        if (store.nowView == VIEW_TYPE.WEB) {
            document.addEventListener('keydown', (e) => {
                if (e && e.keyCode === 122) {
                    e.preventDefault() // 阻止默认事件
                    screenfull.toggle();
                }
            })
            screenfull.onchange(() => {
                store.toggleTool[TOOLS.FULL_SCREEN.TOOL] = screenfull.isFullscreen;
            });
            window.onbeforeunload = function () {
                return "";
            };
        }
    }

    getUrlParam(target) {
        let argumentMap = new Map();

        location.search.slice(1).split("&").forEach(element => {
            let argument = element.split("=");
            argumentMap.set(argument[0], argument[1]);
        });

        return argumentMap.get(target);
    }

    send() {
        let event = arguments[0];
        if (this.webBackgroundEvent.has(event)) {
            console.log("background web 觸發事件", event);
            this.webBackgroundEvent.get(event)(arguments);
        } else {
            console.log("background web 尚未註冊此事件", event);
        }
    }

    getPath() {
        //取得並設定書本相關資訊
        // BookData.Instance.setBookPath(`${location.origin}/ebook`);

        const originURL = location.origin;
        const pathName = location.pathname.split('/').slice(0, -1).join('/');
        const bookId = location.href.match(/bookId=([^&]*)/)[1];

        BookData.Instance.setBookPath(`${originURL}${pathName}/book/${bookId}`);
        BookData.Instance.setAppPath(`${originURL}${pathName}`);

        BookData.Instance.loadBookConfig();
        BookData.Instance.loadBookVersion();
        setTimeout(() => {
            window.app.$refs.directory.getDirectoryData();
        }, 1000);
    }

    async getUserRecord() {
        let recordData = await window.app.$refs.fetchRecord.fetchUserRecord();
        for (let i = 0; i < recordData.length; i++) {
            let record = recordData[i];
            record.file_path = `${USER_RECORD_BUCKET}${record.uid}/${record.book_id}/${record.log_name}.json`;
        }
        setTimeout(() => {
            SaveTool._instance.showUserRecord(recordData);
        }, 1000);
    }

    async loadRecord() {
        var path = arguments[0][1];
        path += `?t=${new Date()}`;

        const folderPath = path.substring(0, path.lastIndexOf(".")) + "/";

        let response = await fetch(path);
        let data = await response.json();

        console.log(data);

        const fixedData = await this.recordHandlerWeb.adjustRecord(data, folderPath);
        SaveTool._instance.loadUserRecord(JSON.parse(fixedData), path);
    }

    checkLogNameRepeat() {
        //檢查存檔名稱重複事件
        var bookId = arguments[0][1]; var userId = arguments[0][2]; var logName = arguments[0][3]
        let logCheckResult = null;
        const self = this;
        API_GET_USER_RECORD(bookId, userId)
            .then(response => {
                return response.json();
            }).then(data => {
                var userRecordOnline = data.content.slice();

                self.recordTask = {
                    taskName: logName,
                    taskType: RECORD_TASK_TYPE.UPLOAD_TO_CLOUD,
                    updateTime: timeFormat(new Date()),
                };
                var i = 0;
                for (i = 0; i < userRecordOnline.length; i++) {
                    if (userRecordOnline[i].log_name == logName) {
                        self.recordTask.log_id = userRecordOnline[i].log_id;
                        self.recordTask.taskType = RECORD_TASK_TYPE.UPDATE_TO_CLOUD;

                        logCheckResult = {
                            id: userRecordOnline[i].log_id,
                            status: userRecordOnline[i].save_staus
                        }
                        break;
                    }
                }

                //確認覆蓋視窗
                SaveTool._instance.handleNameRepeatCheck(logCheckResult ? logCheckResult : -1);
            });
    }

    async addUserRecord() {
        //雲端儲存新檔案
        let bookId = arguments[0][1]; let userId = arguments[0][2];
        let logName = arguments[0][3]; let uploadData = arguments[0][4];
        const result = await TaskControl.Instance.uploadTask(this.recordTask, uploadData);

        if (result.success) {
            SaveTool._instance.showFinish(result);
        }
    }

    async updateUserRecord() {
        //覆蓋檔案
        let uuid = arguments[0][1]; let updateData = arguments[0][2];
        const result = await TaskControl.Instance.uploadTask(this.recordTask, updateData);

        if (result.success) {
            SaveTool._instance.showFinish(result);
        }
    }

    async deleteUserRecord() {
        //刪除檔案
        let recordId = arguments[0][1]; let recordName = arguments[0][2];
        let recordFilePath = arguments[0][3];
        let deleteTask = {
            taskName: recordName,
            taskType: RECORD_TASK_TYPE.DELETE_CLOUD,
            updateTime: timeFormat(new Date()),
        };
        await TaskControl.Instance.deleteTask(deleteTask);

        if (store.updateUserRecord) {
            store.updateUserRecord = false;
            this.getUserRecord();
        }
    }

    openWebSite() {
        let url = arguments[0][1];
        window.open(url);
    }

    async handleInsertImage(values) {
        const file = values[1];
        const key = file.name + file.lastModified;
        const imageName = RANDOM_CHAR(20) + "." + file.name.split(".")[1];
        const dataUrl = await READ_FILE_AS_DATA_URL(file)
        EventBus.getInstance().getAppRefs().insertPicture.setImage(dataUrl, imageName);
        ImageControl.Instance.addImageFile(key, dataUrl, imageName, file);
    }
}